import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inventory_with_allocations_report_get_inventory_by_lotService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lot_id: number }): 
  Promise<{ result: { TotalPackagedAmount?: number, AvailablePackagedAmount?: number, InactiveAmount?: number, Allocated?: number, SoftAllocated?: number, LotId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lot_id)) {
      $missingRequiredInParams.push('\'lot_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lot_id: number    }) {
        if(isNil($inParams.lot_id)) {
          return true; 
        }
      return false;
    }
}
